import {Box} from '@mui/material';
import {array, node} from 'prop-types';
import React, {useRef} from 'react';

import {Virtuoso} from 'react-virtuoso';
import CollectionItem from './CollectionItem.jsx';
import {useGetProductsCount} from '@api/products';

const ListItem = ({children, ...props}) => {
  return (
    <Box
      {...props}
      style={{margin: 0}}
      sx={{
        paddingBottom: 1,
        paddingX: 2,
        '&:first-of-type': {
          paddingTop: 1,
        },
      }}
    >
      {children}
    </Box>
  );
};

ListItem.propTypes = {
  children: node,
};

const CollectionsList = ({collections}) => {
  const listRef = useRef();

  const {data: productCount} = useGetProductsCount();

  const renderCollectionItem = index => {
    const collection = collections[index];
    return (
      <CollectionItem
        key={collection.id}
        collection={collection}
        productCount={productCount}
      />
    );
  };

  return (
    <Virtuoso
      ref={listRef}
      totalCount={collections?.length}
      itemContent={renderCollectionItem}
      overscan={500}
      components={{
        Item: ListItem,
      }}
    />
  );
};

CollectionsList.propTypes = {
  collections: array,
};

export default CollectionsList;
